import React from 'react';

const ErrorPage = () => {
    return (
        <div style={{"margin": "25%"}} > 404 Page Not Found </div>
    )
}

export default ErrorPage